import React, { Component } from 'react';
import { Button, Spin, message, Input } from 'antd';
import TableC from '../../basicElement/TableC';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Filter from './Filter';
import SideNav from '../SiteSider';

function EditableTable({ index, value, name, editable, onChange }) {
    return (
        editable ?
            <Input
                placeholder="请输入"
                value={value}
                style={{width:'100%'}}
                onChange={e => onChange(e, index, name)}
            />
        :
            <span>{value}</span>
    );
}

class ResearchCenterCost extends Component {
    state = {
        data: [],
        loading: false,
        sortParams: {},
        curParams: {},
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.loadData();
        this.queryInvestigationStageByInvId();
    }

    loadData = () => {
        const { curParams, pagination } = this.state;
        const { siteId } = sessionStorage;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = {};
        if (siteId > 0) {
            params.investigationSiteId = siteId;
        }
        const options = {
            url: `${API_URL.site.queryInvestigationSiteFee}`,
            data: {
                offset: current,
                limit: pageSize,
                ...curParams,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: { ...searchParams },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const url = API_URL.site.exportInvestigationSiteFee;
        ExportUtil.export({ ...sortParams, ...curParams }, null, url);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            }
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const columns = [{
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            fixed: 'left',
            width: 110,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            fixed: 'left',
            width: 160,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 80,
        }, {
            title: '牵头费',
            dataIndex: 'leadFee',
            key: 'leadFee',
            width: 120,
            render: (text, record, index) => {
                const { editable } = record;
                return <EditableTable name='leadFee' value={text} index={index} editable={editable} onChange={this.handleChange} />;
            }
        }, {
            title: '研究者费',
            dataIndex: 'researcherFee',
            key: 'researcherFee',
            width: 120,
            render: (text, record, index) => {
                const { editable } = record;
                return <EditableTable name='researcherFee' value={text} index={index} editable={editable} onChange={this.handleChange} />;
            }
        }, {
            title: '患者交通补助',
            dataIndex: 'patientTransportationSubsidy',
            key: 'patientTransportationSubsidy',
            width: 120,
            render: (text, record, index) => {
                const { editable } = record;
                return <EditableTable name='patientTransportationSubsidy' value={text} index={index} editable={editable} onChange={this.handleChange} />;
            }
        }, {
            title: '患者推荐费',
            dataIndex: 'patientReferralFee',
            key: 'patientReferralFee',
            width: 120,
            render: (text, record, index) => {
                const { editable } = record;
                return <EditableTable name='patientReferralFee' value={text} index={index} editable={editable} onChange={this.handleChange} />;
            }
        }, {
            title: '其他（备注）',
            dataIndex: 'otherRemarks',
            key: 'otherRemarks',
            width: 200,
            render: (text, record, index) => {
                const { editable } = record;
                return <EditableTable name='otherRemarks' value={text} index={index} editable={editable} onChange={this.handleChange} />;
            }
        }];
        const { curRole } = sessionStorage;
        if (curRole === 'PM' || curRole === 'PA' || curRole === 'CRC') {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                fixed: 'right',
                width: 80,
                render: (text, record, index) => {
                    const { editable } = record;
                    return <a onClick={() => this.canEditByInvStatus(() => this.edit(index))}>{editable ? '保存' : '编辑'}</a>
                }
            });
        }
        return columns;
    }

    handleChange = (e, index, key) => {
        const { data } = this.state;
        const value = e.target.value;
        if (value && (value.length > 255)) {
            message.warning('最大可输入255个字符');
            return;
        }
        data[index][key] = value;
        this.setState({ data: [...data] });
    }

    edit = (index) => {
        const { data } = this.state;
        const target = data[index];
        if (target.editable) {
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.site.editInvestigationSiteFee,
                data: target,
                dataType: 'json',
                doneResult: res => {
                    const { success } = res;
                    message.success(success);
                    this.setState({ loading: false }, () => {
                        this.loadData();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                },
            };
            $.sendRequest(options);
        } else {
            target.editable = 1;
            this.setState({ target });
        }
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { siteId } = sessionStorage;
        const { data, loading, pagination, searchParams } = this.state;
        const isSingleSite = siteId > 0;
        return (
            <div className="content">
                <SideNav selectKey='researchCenterCost' />
                <div className="main">
                    <div className="main-content">
                        <Filter
                            search={isSingleSite ? '' : this.search}
                            params={searchParams}
                            onChange={this.handleFilterChange}
                            buttons={[
                                <Button key="export" type="primary" style={{ position: isSingleSite ? 'absolute' : 'static', right: 30, marginLeft: 10 }} onClick={this.export}>导出</Button>
                            ]}
                        />
                        <TableC
                            data={data}
                            loading={loading}
                            className="researchCenterCost"
                            columns={this.getColumns()}
                            rowKey="investigationSiteId"
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default ResearchCenterCost;


// WEBPACK FOOTER //
// ./src/components/site/researchCenterCost/index.js